import React, { useEffect, useState } from "react";
import "./GroupLoansListMembers.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansMemberBalances from "../GroupLoansMemberBalances/GroupLoansMemberBalances";
import CloseIcon from "@mui/icons-material/Close";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansListMembers = ({ selectedLoan, setSelectedView, selectedView, showMoreDetails }) => {
    const [membersArray, setMembersArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [membersListView, setMembersListView] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    const [selectedMemberName, setSelectedMemberName] = useState(false);

    useEffect(()=>{
        getListOfMembers();
    },[]);

    const columns = [
        {
            label: 'Group ID',
            getValue: (row) => row?.lgm?.groupid ?? ''
        },
        {
            label: 'Member Name',
            getValue: (row) => `${row?.u?.firstName} ${row?.u?.lastName}`  ?? ''
        },
        {
            label: 'Date Added',
            getValue: (row) => row?.lgm?.dateadded ?? ''
        },
        {
            label: 'Role',
            getValue: (row) => row?.lgm?.role == "1" ? "Member" : 
            selectedMember?.lgm?.status == "2" ? "Approver" :
            selectedMember?.lgm?.status == "3" ? "Admin" :
            "Member"
        },
        {
            label: 'Status',
            getValue: (row) => row?.lgm?.status == "0" ? "Pending Confirmation" : 
            selectedMember?.lgm?.status == "1" ? "Confirmed" :
            selectedMember?.lgm?.status == "2" ? "Rejected" :
            selectedMember?.lgm?.status == "3" ? "Removed" :
            "N/A"             
        }
    ];

    const getListOfMembers = async() => {
        try {
            // const response = await commonRunQuery(287, selectedLoan?.loangroups?.groupid ? selectedLoan?.loangroups?.groupid : selectedLoan?.lgm?.groupid);
            const response = await commonRunQuery(288, 20);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setMembersArray(groupsArray);
              console.log("getListOfMembers_response==========",groupsArray);
            } else {
                setMembersArray([]);
            }
        } catch (error) {
            console.log("getListOfMembers_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        console.log("firstName------------",loan?.u?.firstName)
        console.log("lastName------------",loan?.u?.lastName)
        setAnchorEl(event.currentTarget);
        setSelectedMemberName(`${loan?.u?.firstName} ${loan?.u?.lastName}`);
        setSelectedMember(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box>
            {
                membersListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List of Members
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setSelectedView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                membersListView == null && <Box className="mt-4">
                    <GroupLoansTable
                        data={membersArray} 
                        columns={columns} 
                        title="List of Members" 
                        formatRow={formatedRows} 
                        viewMenu={true}
                        handleMenuOpen={handleMenuOpen}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            {
                membersListView == "memberBalances" && <GroupLoansMemberBalances selectedLoan={selectedLoan} setMembersListView={setMembersListView} selectedMemberName={selectedMemberName} />
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                {showMoreDetails && <MenuItem
                    onClick={() => {
                        setMembersListView('memberBalances');
                        handleMenuClose();
                    }}
                >
                    Member Balances
                </MenuItem>}
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <div className="loans-details-info-drawer">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="70vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedMember && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        {/* Left Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "User Id", value: selectedMember?.lgm?.confirmationrefno || "N/A" },
                                                { label: "First Name", value: selectedMember?.u?.firstName || "-" },
                                                { label: "Last Name", value: selectedMember?.u?.lastName || "-" },
                                                { label: "Group Id", value: selectedMember?.lgm?.groupid || "N/A" },
                                                { label: "Group Name", value: selectedMember?.lg?.groupname || "N/A" },
                                                { label: "Status", value: selectedMember?.lgm?.status == "0" ? "Pending Confirmation" : 
                                                    selectedMember?.lgm?.status == "1" ? "Confirmed" :
                                                    selectedMember?.lgm?.status == "2" ? "Rejected" :
                                                    selectedMember?.lgm?.status == "3" ? "Removed" :
                                                    "N/A" 
                                                },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* Right Column */}
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Date Added", value: selectedMember?.lgm?.dateadded || "N/A" },
                                                { label: "Date Confirmed", value: selectedMember?.lgm?.dateconfirmed || "N/A" },
                                                { label: "Date Rejected", value: selectedMember?.lgm?.daterejected || "N/A" },
                                                { label: "Date Removed", value: selectedMember?.lgm?.dateremoved || "N/A" },
                                                { label: "Role", value: selectedMember?.lgm?.role == "1" ? "Member" : 
                                                    selectedMember?.lgm?.status == "2" ? "Approver" :
                                                    selectedMember?.lgm?.status == "3" ? "Admin" :
                                                    "Member" 
                                                },
                                            ].filter(Boolean).map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Member Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedMember && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "User Id", value: selectedMember?.lgm?.confirmationrefno || "N/A" },
                                                { label: "First Name", value: selectedMember?.u?.firstName || "-" },
                                                { label: "Last Name", value: selectedMember?.u?.lastName || "-" },
                                                { label: "Group Id", value: selectedMember?.lgm?.groupid || "N/A" },
                                                { label: "Group Name", value: selectedMember?.lg?.groupname || "N/A" },
                                                { label: "Status", value: selectedMember?.lgm?.status || "N/A" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Date Added", value: selectedMember?.lgm?.dateadded || "N/A" },
                                                { label: "Date Confirmed", value: selectedMember?.lgm?.dateconfirmed || "N/A" },
                                                { label: "Date Rejected", value: selectedMember?.lgm?.daterejected || "N/A" },
                                                { label: "Date Removed", value: selectedMember?.lgm?.dateremoved || "N/A" },
                                                { label: "Role", value: selectedMember?.lgm?.role || "N/A" },
                                            ].filter(Boolean).map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansListMembers;
